import Layout from '@/components/feature/Layout';
import { companyInfo } from '@/mocks/company';
import { products } from '@/mocks/products';
import { Link } from 'react-router-dom';

const whatsappMessage = encodeURIComponent('Olá! Estou no site da Maquinasdesoldageomembrana.com.br e gostaria de informações sobre máquinas de solda de geomembrana.');
const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=${whatsappMessage}`;

const schema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Comprar Máquina de Solda de Geomembrana',
  description: 'Compre sua máquina de solda geomembrana com suporte técnico, garantia e envio para todo o Brasil.',
  url: 'https://maquinadesoldageomembrana.com.br/comprar-maquina-de-solda-de-geomembrana',
  inLanguage: 'pt-BR',
};

export default function ComprarPage() {
  return (
    <Layout>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="w-full px-4 md:px-6 lg:px-10 pt-28 md:pt-32 pb-16 md:pb-24">
        <nav className="text-xs text-foreground-400 mb-6">
          <Link to="/" className="hover:text-primary-600 cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line mx-1" />
          <span className="text-foreground-600">Comprar</span>
        </nav>

        <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 uppercase leading-tight mb-4">
          Comprar Máquina de Solda de Geomembrana
        </h1>
        <p className="text-foreground-500 text-sm md:text-base max-w-2xl mb-10">
          Distribuidor oficial no Brasil. Envio para todos os estados. Suporte técnico pós-venda com peças originais de fábrica.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8 mb-12">
          {products.filter((p) => p.category === 'Cunha Quente').map((product) => (
            <div key={product.id} className="bg-white rounded-2xl border border-background-200/70 overflow-hidden flex flex-col">
              <div className="relative w-full h-48 bg-gradient-to-br from-background-100 to-background-200 flex items-center justify-center p-5">
                {product.badge && <span className="absolute top-3 left-3 bg-primary-500 text-white text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wide">{product.badge}</span>}
                <img alt={product.name} className="h-full w-full object-contain" src={product.image} />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <Link to={`/modelos-de-maquinas/${product.slug}`} className="font-heading text-xl font-bold text-foreground-950 uppercase mb-1 hover:text-primary-600 transition-colors cursor-pointer">{product.name}</Link>
                <p className="text-primary-600 text-xs font-bold uppercase tracking-wide mb-3">{product.category}</p>
                <div className="space-y-2 mb-5">
                  {Object.entries(product.specs).map(([k, v]) => (
                    <div key={k} className="flex items-center justify-between text-xs">
                      <span className="text-foreground-400 uppercase tracking-wide">{k}</span>
                      <span className="text-foreground-800 font-medium">{v}</span>
                    </div>
                  ))}
                </div>
                <Link
                  to={`/modelos-de-maquinas/${product.slug}`}
                  className="mb-2 w-full inline-flex items-center justify-center gap-2 border-2 border-primary-500 text-primary-600 hover:bg-primary-500 hover:text-white font-bold text-sm px-4 py-2.5 rounded-xl transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
                >
                  <i className="ri-information-line" /> Ver detalhes
                </Link>
                <a
                  href={`https://wa.me/${companyInfo.whatsapp}?text=${whatsappMessage}`}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="mt-2 w-full inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-sm px-4 py-3 rounded-xl transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
                >
                  <i className="ri-whatsapp-line" /> Solicitar Orçamento
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-foreground-950 rounded-2xl p-8 md:p-12 text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white uppercase mb-4">Garantia e Suporte</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-8">
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/20 mb-3">
                <i className="ri-shield-check-line text-primary-400 text-xl" />
              </div>
              <h4 className="text-white font-bold text-sm uppercase mb-1">Garantia 6-12 Meses</h4>
              <p className="text-foreground-400 text-xs">Contra defeitos de fabricação com peças originais.</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/20 mb-3">
                <i className="ri-tools-line text-primary-400 text-xl" />
              </div>
              <h4 className="text-white font-bold text-sm uppercase mb-1">Suporte Técnico</h4>
              <p className="text-foreground-400 text-xs">Atendimento via WhatsApp com técnicos especializados.</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/20 mb-3">
                <i className="ri-truck-line text-primary-400 text-xl" />
              </div>
              <h4 className="text-white font-bold text-sm uppercase mb-1">Envio para Todo Brasil</h4>
              <p className="text-foreground-400 text-xs">3 a 10 dias úteis com transportadora especializada.</p>
            </div>
          </div>
        </div>

        <div className="bg-primary-50 rounded-2xl border border-primary-200/70 p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950 uppercase mb-1">Não tem certeza qual modelo escolher?</h3>
            <p className="text-foreground-500 text-sm">Conte-nos sobre seu projeto e indicamos o equipamento ideal.</p>
          </div>
          <a href={whatsappUrl} target="_blank" rel="nofollow noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-sm px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide flex-shrink-0">
            <i className="ri-whatsapp-line" /> Falar com Especialista
          </a>
        </div>
      </div>
    </Layout>
  );
}